export const CHROME_DOWNLOAD = "https://dl.precyz.com/chrome/precyz-extension.zip";
export const CHROME_EXTENSION_ID = "";

export function pairingPayload(token: string): { install_token: string } {
  return { install_token: token };
}

export function offerInstallToken(token: string): { install_token: string } {
  const payload = pairingPayload(token);
  const send = (globalThis as { chrome?: { runtime?: { sendMessage?: (...args: unknown[]) => void } } }).chrome?.runtime?.sendMessage;
  if (CHROME_EXTENSION_ID && typeof send === "function") {
    send(CHROME_EXTENSION_ID, payload, () => undefined);
  }
  return payload;
}
